module.exports = __webpack_public_path__ + "images/emoji/frog.8fc6ef18af7b3ff72f4b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/frog.png
// module id = 2Hm6
// module chunks = 1